/**
 * useCurrency — React hook that reads system_settings and hydrates
 * the global currency cache in utils/currency.ts.
 *
 * Mount this once near the top of the app (or in any page that needs it).
 * After mount, fmtCurrency() / fmtMoney() work everywhere.
 */
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api';
import { _setCurrencyConfig, fmtCurrency, fmtMoney, getCurrencyConfig } from '../utils/currency';

export function useCurrency() {
  const q = useQuery({
    queryKey: ['admin-settings'],
    queryFn: adminApi.getSettings,
    staleTime: 5 * 60_000,
  });

  if (q.data) {
    _setCurrencyConfig({
      symbol:   q.data.currency_symbol   ?? '$',
      code:     q.data.default_currency  ?? 'USD',
      locale:   q.data.currency_locale   ?? 'en-US',
      decimals: parseInt(q.data.currency_decimals ?? '2', 10),
    });
  }

  const cfg = getCurrencyConfig();
  const fmt = fmtCurrency;

  return { fmt, fmtMoney, symbol: cfg.symbol, code: cfg.code, locale: cfg.locale, decimals: cfg.decimals, cfg };
}
